import bitunix from "@/public/leaderboards/bitunix-full.svg";
import pionex from "@/public/leaderboards/pionex-full.svg";
import phemex from "@/public/leaderboards/phemex-full.svg";

export const exchanges = [
  {
    name: "Bitunix",
    color: "#D9F9B9",
    logo: bitunix,
    totalPrize: 150000,
    totalWinners: 1275,
    usersCount: 2984,
    topUsers: [
      {
        avatarURL:
          "https://cdn.discordapp.com/avatars/587710612499595265/6432aa9511b914b0abb9c8b310e381da.png",
        name: "Ju********",
        tradingVolume: 374735.05,
        cashback: 2900,
      },
      {
        avatarURL:
          "https://cdn.discordapp.com/avatars/587710612499595265/6432aa9511b914b0abb9c8b310e381da.png",
        name: "Ka********",
        tradingVolume: 204735.05,
        cashback: 2500,
      },
      {
        avatarURL:
          "https://cdn.discordapp.com/avatars/587710612499595265/6432aa9511b914b0abb9c8b310e381da.png",
        name: "Wi********",
        tradingVolume: 190735.05,
        cashback: 2200,
      },
      {
        avatarURL:
          "https://cdn.discordapp.com/avatars/587710612499595265/6432aa9511b914b0abb9c8b310e381da.png",
        name: "Us********",
        tradingVolume: 190735.05,
        cashback: 2000,
      },
      {
        avatarURL:
          "https://cdn.discordapp.com/avatars/587710612499595265/6432aa9511b914b0abb9c8b310e381da.png",
        name: "Co********",
        tradingVolume: 190735.05,
        cashback: 1800,
      },
    ],
  },
  {
    name: "Pionex",
    color: "#FF8D28",
    logo: pionex,
    totalPrize: 48000,
    totalWinners: 575,
    usersCount: 1984,
    topUsers: [
      {
        avatarURL:
          "https://cdn.discordapp.com/avatars/587710612499595265/6432aa9511b914b0abb9c8b310e381da.png",
        name: "Ju********",
        tradingVolume: 374735.05,
        cashback: 1700,
      },
      {
        avatarURL:
          "https://cdn.discordapp.com/avatars/587710612499595265/6432aa9511b914b0abb9c8b310e381da.png",
        name: "Ka********",
        tradingVolume: 204735.05,
        cashback: 1600,
      },
      {
        avatarURL:
          "https://cdn.discordapp.com/avatars/587710612499595265/6432aa9511b914b0abb9c8b310e381da.png",
        name: "Wi********",
        tradingVolume: 190735.05,
        cashback: 1500,
      },
      {
        avatarURL:
          "https://cdn.discordapp.com/avatars/587710612499595265/6432aa9511b914b0abb9c8b310e381da.png",
        name: "Us********",
        tradingVolume: 190735.05,
        cashback: 1400,
      },
      {
        avatarURL:
          "https://cdn.discordapp.com/avatars/587710612499595265/6432aa9511b914b0abb9c8b310e381da.png",
        name: "Co********",
        tradingVolume: 190735.05,
        cashback: 1300,
      },
    ],
  },
  {
    name: "Phemex",
    color: "#0B5BE0",
    logo: phemex,
    totalPrize: 12000,
    totalWinners: 275,
    usersCount: 984,
    topUsers: [
      {
        avatarURL:
          "https://cdn.discordapp.com/avatars/587710612499595265/6432aa9511b914b0abb9c8b310e381da.png",
        name: "Ju********",
        tradingVolume: 374735.05,
        cashback: 1200,
      },
      {
        avatarURL:
          "https://cdn.discordapp.com/avatars/587710612499595265/6432aa9511b914b0abb9c8b310e381da.png",
        name: "Ka********",
        tradingVolume: 204735.05,
        cashback: 1100,
      },
      {
        avatarURL:
          "https://cdn.discordapp.com/avatars/587710612499595265/6432aa9511b914b0abb9c8b310e381da.png",
        name: "Wi********",
        tradingVolume: 190735.05,
        cashback: 1000,
      },
      {
        avatarURL:
          "https://cdn.discordapp.com/avatars/587710612499595265/6432aa9511b914b0abb9c8b310e381da.png",
        name: "Us********",
        tradingVolume: 190735.05,
        cashback: 900,
      },
      {
        avatarURL:
          "https://cdn.discordapp.com/avatars/587710612499595265/6432aa9511b914b0abb9c8b310e381da.png",
        name: "Co********",
        tradingVolume: 190735.05,
        cashback: 800,
      },
    ],
  },
];
